//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */

const { gagoSources, mapboxSources } = require('./gago-source-reference');
const gagoLayerReference = require('./gago-layer-reference');
const { gagoPaint, mapboxPaint } = require('./gago-paint-reference');

const {
    addSource,
    addLayer,
    addPaint,
    modifySource,
    modifyPaint,
} = require('./util');


exports.modifyReference = function (v8) {
    addGagoReference(v8, gagoSources, addSource);
    addGagoReference(v8, gagoPaint, addPaint);
    addGagoReference(v8, gagoLayerReference, addLayer);

    modifyMapboxReference(v8, mapboxSources, modifySource);
    modifyMapboxReference(v8, mapboxPaint, modifyPaint);
};

function addGagoReference(v8, reference, cb) {
    Object.keys(reference).forEach(name => {
        cb(v8, name, reference[name]);
    });
}

function modifyMapboxReference(v8, reference, cb) {
    Object.keys(reference).forEach(name => {
        const sourceOrLayerOrPaint = reference[name];
        Object.keys(sourceOrLayerOrPaint).forEach(key => {
            cb(v8, name, key, sourceOrLayerOrPaint[key]);
        });
    });
}
